import { render, staticRenderFns } from "./ReturnReasons.vue?vue&type=template&id=5fb80d55"
import script from "./ReturnReasons.vue?vue&type=script&lang=ts"
export * from "./ReturnReasons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports